import Vue from "vue";
import { LoginBox } from "../../components/login";

export const Login = Vue.extend({
    template: require("./login.html"),
    components: { LoginBox }
});
